import { render, staticRenderFns } from "./LivingOptionTags.vue?vue&type=template&id=20df1675&scoped=true&"
import script from "./LivingOptionTags.vue?vue&type=script&lang=js&"
export * from "./LivingOptionTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df1675",
  null
  
)

export default component.exports